import { Bar } from 'vue-chartjs'
export default {
  extends: Bar,
  props: ['chart', 'display'],
  watch: {
    chartData: function () {
      this.renderChart({
        labels: this.chart.labels,
        datasets: this.chart.datasets,
      }, {
        responsive: true, maintainAspectRatio: false, onClick: this.handle, legend: {
          display: this.display
        },
      });
    }
  },
  mounted() {
    if (this.chart == null)
      return;
    this.renderChart({
      labels: this.chart.labels,
      datasets: this.chart.datasets,
    }, {
      responsive: true, maintainAspectRatio: false, onClick: this.handle, legend: {
        display: this.display
      },
    })
  },
  methods: {
    handle(point, event) {
      const item = event[0]
     // console.log(item)
     // console.log(this.chart.datasets[0].label)
      this.$emit('on-receive', {
        index: item._index,
        backgroundColor: item._view.backgroundColor,
        value: this.chart.labels[item._index],
        did:this.chart.datasets[0].label,
      })
    }
  }

}